export default "__VITE_ASSET__DtyqMR56__"